'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _toolbar = require('../../toolbar');

var _toolbar2 = _interopRequireDefault(_toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DancersController = function DancersController($document, config) {
  _classCallCheck(this, DancersController);

  this.config = config;
  this._svc = {
    $document: $document
  };

  $document.scrollTop(0, 1000);
};

exports.default = angular.module('ifeis.routes.dancers', ['ui.router', 'ifeis.toolbar']).config(function ($stateProvider) {
  $stateProvider.state('dancers', {
    url: '/dancers',
    controller: 'DancersController',
    controllerAs: 'ctrl',
    template: require('./tpl.html')
  });
}).controller('DancersController', DancersController);


//////////////////
// WEBPACK FOOTER
// ./routes/dancers/index.js
// module id = 519
// module chunks = 0